import { PointType } from '@shared/types/geoTypes'

import { Gender, Phone } from '../types'

export class UserModel {
  constructor(
    public id: number,
    public phone: Phone,
    public gender: Gender,
    public age: number,
    public geo: PointType | null,
    public sourceName: string,
    public address: string,
    public telegramId: string | null,
    public hasWhatsApp: boolean,
    public hasViber: boolean
  ) {}

  public getShortGender(translate: (key: string) => string): string {
    if (!this.gender) {
      return '?'
    }
    return this.gender === 'male'
      ? translate('male_short')
      : translate('female_short')
  }
}
